import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Icon } from 'semantic-ui-react';
import { showExtendCNInvtiationModal } from 'actions/modal';
import { extendCNInvitationTicket } from 'actions/waitingArea';
import { displayGlobalMessage } from 'actions/globalMessage';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';

const ExtendConsultNowInvitationContainer = (props) => {
  const dispatch = useDispatch();
  const selectedConsultNowCaller = useSelector((state) => state.waitingAreaReducer.selectedConsultNowCaller);

  let [extending5, setExtending5] = useState(false);
  let [extending10, setExtending10] = useState(false);
  let saveClasses = 'ui button max-width mrlnull mrbnull';

  const extendInvitation = (extendTime) => {
    let payload = {
      minutes: extendTime,
    };
    let cb = (result, err) => {
      if (result) {
        setExtending5(false);
        setExtending10(false);

        dispatch(showExtendCNInvtiationModal(false));
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.ExtendConsultNowInvitation.SuccessMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      }
      // TODO-HH - Custom error handling
      setExtending5(false);
      setExtending10(false);
    };
    if (extendTime === 5) {
      setExtending5(true);
    } else {
      setExtending10(true);
    }
    dispatch(extendCNInvitationTicket(selectedConsultNowCaller.authTicketId, payload, cb));
  };
  return (
    <Modal show={true} hideWhenClickAway={false} className="single-column-modal">
      <PopupHeader
        title={APP.LANGUAGE.ExtendConsultNowInvitation.Title}
        subtitle={props.waitingArea.name}
        hideHelp={true}
      />
      <div className="content">
        <div className="ui form mrbl pdtsss">
          <div className="title-sms">{APP.LANGUAGE.ExtendConsultNowInvitation.Content}</div>
          <div className="limited-width-160 mrtm">
            <button
              tabIndex="1"
              type="button"
              className={extending5 ? saveClasses + ' loading' : saveClasses + ' no-icon-btn'}
              onClick={() => extendInvitation(5)}
            >
              {APP.LANGUAGE.ExtendConsultNowInvitation.FiveMinuteBtn}
            </button>
          </div>
          <div className="limited-width-160 mrtm">
            <button
              tabIndex="2"
              type="button"
              className={extending10 ? saveClasses + ' loading' : saveClasses + ' no-icon-btn cstm-tenbtn'}
              onClick={() => extendInvitation(10)}
            >
              {APP.LANGUAGE.ExtendConsultNowInvitation.TenMinuteBtn}
            </button>
          </div>
          <div className="limited-width-160 mrtm">
            <button
              tabIndex="3"
              type="button"
              className="ui labeled icon button icon max-width color-bad-things left-text color-bad-things-hover color-white mrlnull mrbnull no-icon-btn"
              onClick={() => dispatch(showExtendCNInvtiationModal(false))}
            >
              <i className="remove  icon" />
              {APP.LANGUAGE.Close}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ExtendConsultNowInvitationContainer;
